import { asMultiStyleConfig } from '../../utils/theme';
export var ErrorBanner = asMultiStyleConfig({
  parts: ['alert', 'body', 'errorIcon', 'title', 'subtitle', 'message', 'contentBody'],
  baseStyle: {
    alert: {
      w: '100%',
      p: [6, 8],
      borderRadius: 'md',
      backgroundColor: 'red.1050',
      border: '2px solid',
      borderColor: 'red.700'
    },
    body: {
      mx: 'auto',
      textAlign: 'center',
      borderColor: 'none'
    },
    errorIcon: {
      height: ['2rem', '4rem'],
      width: ['2rem', '4rem'],
      color: 'red.700',
      mx: 'auto'
    },
    title: {
      fontSize: ['lg', 'xl'],
      fontWeight: 'bold'
    },
    subtitle: {
      fontSize: ['md', 'lg'],
      fontWeight: 'bold'
    },
    message: {
      fontSize: ['sm', 'md']
    },
    contentBody: {
      mt: 6
    }
  }
});